import{e as n}from"./chunk-V4NH4KGH.js";import{a as r}from"./chunk-CKDAMVQL.js";import{m as o}from"./chunk-HBP5N4FR.js";o();function f(e){let c=r.getState(),t=n(c);return e?t&&!isNaN(t)?Math.max(t,e.nonce):e.nonce:t}export{f as a};
//# sourceMappingURL=chunk-3NPI7JA7.js.map
